import { render, staticRenderFns } from "./OrderPropertyList.vue?vue&type=template&id=bd598d7e&"
import script from "./OrderPropertyList.vue?vue&type=script&lang=js&"
export * from "./OrderPropertyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports